import React from 'react';
import CaseStudyPage from './CaseStudyPage';
import { caseStudies } from './caseStudyContent';

export default function KinzyClubCaseStudy() {
  return <CaseStudyPage study={caseStudies.kinzy} />;
}